import { useContext } from "react";
import { AuthContext } from "../utilities/customHooks";

export default function ImpersonationBanner() {
  const auth = useContext(AuthContext);

  if (!auth?.isImpersonating) return null;

  return (
    <div className="sticky top-14 z-40 flex items-center justify-between gap-4 bg-amber-500 px-6 py-2 text-sm font-medium text-white shadow-md">
      <span>
        Viewing as <strong>{auth.userName}</strong> ({auth.userRole} / {auth.userRegion})
        {auth.impersonatorName && (
          <span className="ml-2 opacity-80">
            &mdash; logged in as {auth.impersonatorName}
          </span>
        )}
      </span>
      <button
        onClick={() => auth.exitImpersonation()}
        className="rounded bg-white px-3 py-1 text-sm font-semibold text-amber-700 hover:bg-amber-50 transition-colors"
      >
        Exit Impersonation
      </button>
    </div>
  );
}
